import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import LA from "../img/LA.png";
import mathBro from "../img/math-bro.png";
import Duplicatebro from "../img/Mathematics-pana.png";
import CoursesDetail5 from "../components/CoursesDetail5";
import CourseDetail51 from "../components/CourseDetail51";

const LinearAlgebra = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["線性代數"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "詳細的線性代數課程，帶你了解機器學習中的主成分分析 (PCA)、Python 實作圖片分析、馬可夫鏈、SVD分解、LU分解、QR 分解、特徵值與特徵向量、施特拉森演算法、可逆矩陣判斷、Gershgorin圓定理。",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={LA} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-linear-algebra/?couponCode=${process.env.REACT_APP_LINEAR_ALGEBRA_COUPON}`}
              >
                <span>{process.env.REACT_APP_LINEAR_ALGEBRA_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-linear-algebra/?couponCode=${process.env.REACT_APP_LINEAR_ALGEBRA_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/wilson-linear-algebra/
                </span>
              </a>
            </p>
          </div>
        </div>
        <CourseDetail51 img={mathBro} />
        <CoursesDetail5 img={Duplicatebro} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default LinearAlgebra;
